import {lazy} from 'react';

const AddUpdateCourse = lazy(() => import('./components/AddUpdateCourse'));

const AddUpdateCatalog = lazy(() => import('./components/AddUpdateCatalog'));

const ViewCourse = lazy(() => import('./components/ViewCourse'));

export const Course = {AddUpdateCourse, AddUpdateCatalog, ViewCourse};
